import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { PrimeNgModule } from "@primeng";
import { BadgeModule } from "primeng/badge";
import { NotificationIndicatorComponent } from "./notification-indicator.component";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
    declarations: [NotificationIndicatorComponent],
    imports: [
        CommonModule,
        PrimeNgModule,
        BadgeModule,
        TooltipModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [NotificationIndicatorComponent]
})
export class NotificationModule {}